'use client';

import { useEffect } from 'react';
import Box from '@mui/material/Box';
import SvgIcon from '@mui/material/SvgIcon';
import IconButton from '@mui/material/IconButton';
import { useColorScheme } from '@mui/material/styles';
import { useSettingsContext } from 'src/components/settings';

// ----------------------------------------------------------------------

export function ThemeButton({
  sx,
  onClose,
  ...other
}) {
  const settings = useSettingsContext();
  const {
    mode,
    setMode
  } = useColorScheme();
  const onChangeMedia = event => {
    setMode(event.matches ? 'dark' : 'light');
    settings.setState({
      colorScheme: event.matches ? 'dark' : 'light'
    });
  };
  useEffect(() => {
    const matchMedia = window.matchMedia('(prefers-color-scheme: dark)');
    if (settings.state.colorScheme === 'system') onChangeMedia(matchMedia);
    matchMedia.addEventListener('change', onChangeMedia);
    return () => matchMedia.removeEventListener('change', onChangeMedia);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return <Box sx={[{
    width: 40,
    height: 40,
    display: 'grid',
    placeItems: 'center'
  }, ...(Array.isArray(sx) ? sx : [sx])]} {...other}>
      <IconButton aria-level="Theme button" onClick={() => onChangeMedia({
      matches: mode === 'light'
    })} color={settings.state.colorScheme === 'dark' ? 'secondary' : 'warning'} sx={{
      p: 0.5,
      backgroundColor: settings.state.colorScheme === 'dark' ? 'var(--palette-secondary-darker)' : 'rgb(var(--palette-warning-mainChannel)/var(--palette-action-hoverOpacity))'
    }}>
        <SvgIcon viewBox="0 0 20 20" sx={{
        height: {
          xs: 24,
          md: 18
        },
        width: {
          xs: 24,
          md: 18
        }
      }}>
          <path {...settings.state.colorScheme === 'dark' ? {
          fill: 'var(--palette-common-white)',
          d: 'm4.2 2.5-.7 1.8-1.8.7 1.8.7.7 1.8.6-1.8L6.7 5l-1.9-.7zm15 8.3a6.7 6.7 0 1 1-6.6-6.6 5.8 5.8 0 0 0 6.6 6.6'
        } : {
          fill: 'var(--palette-warning-main)',
          d: 'M9.3 1.67v2.08h1.4V1.67zM4.6 3.62l-.98.98 1.47 1.47.98-.98zm10.8 0-1.47 1.47.98.98 1.47-1.47zM10 5.14A4.87 4.87 0 0 0 5.14 10 4.87 4.87 0 0 0 10 14.86 4.87 4.87 0 0 0 14.86 10 4.87 4.87 0 0 0 10 5.14m0 1.39A3.46 3.46 0 0 1 13.47 10 3.46 3.46 0 0 1 10 13.47 3.46 3.46 0 0 1 6.53 10 3.46 3.46 0 0 1 10 6.53M1.66 9.3v1.4h2.09V9.3zm14.59 0v1.4h2.08V9.3zM5.09 13.93 3.62 15.4l.98.98 1.47-1.47zm9.82 0-.98.98 1.47 1.47.98-.98zm-5.6 2.32v2.08h1.38v-2.08z'
        }} />
        </SvgIcon>
      </IconButton>
    </Box>;
}